'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus from "./presto.-Site-Tables$-Group-Status.js";
var $p;
/** @constructor */
function $c_Lpresto_SiteTables$GroupStatus$$anon$23() {
  this.JL = null;
  this.CW = null;
  $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus.$ct_Lpresto_SiteTables$GroupStatus__T__T__(this, "Dispon\u00edvel, mas n\u00e3o configurada", "H\u00e1 credenciais dispon\u00edveis, mas nenhuma configurada para o grupo");
}
export { $c_Lpresto_SiteTables$GroupStatus$$anon$23 as $c_Lpresto_SiteTables$GroupStatus$$anon$23 };
$p = $c_Lpresto_SiteTables$GroupStatus$$anon$23.prototype = new $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus.$h_Lpresto_SiteTables$GroupStatus();
$p.constructor = $c_Lpresto_SiteTables$GroupStatus$$anon$23;
/** @constructor */
function $h_Lpresto_SiteTables$GroupStatus$$anon$23() {
}
export { $h_Lpresto_SiteTables$GroupStatus$$anon$23 as $h_Lpresto_SiteTables$GroupStatus$$anon$23 };
$h_Lpresto_SiteTables$GroupStatus$$anon$23.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return "Pending";
});
$p.l = (function() {
  return "Pending";
});
var $d_Lpresto_SiteTables$GroupStatus$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$GroupStatus$$anon$23, "presto.SiteTables$GroupStatus$$anon$23", ({
  RL: 1,
  d7: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_SiteTables$GroupStatus$$anon$23 as $d_Lpresto_SiteTables$GroupStatus$$anon$23 };
//# sourceMappingURL=presto.-Site-Tables$-Group-Status$$anon$23.js.map
